import * as React from 'react';

import { cn } from '@rematter/ui-web/lib';

interface FilterOptionLabelProps {
  label: string;
  badge?: React.ReactNode;
  isSelected: boolean;
}

//
// ⚛️ ⚛️ ⚛️ FILTER OPTION LABEL ⚛️ ⚛️ ⚛️
//
export const FilterOptionLabel: React.FC<FilterOptionLabelProps> = ({
  label,
  badge,
  isSelected,
}) => (
  <div className="@FilterOptionLabel flex w-full items-center gap-2">
    <div
      className={cn(
        'w-0 grow truncate text-sm',
        isSelected ? 'text-neutral' : 'text-neutral/60',
      )}
    >
      {label}
    </div>
    {badge}
  </div>
);
